// extracted by mini-css-extract-plugin
export var banner = "_nx-0";
export var settingRow = "_nx-2";
export var titleIcon = "_nx-1";